import React from 'react'
import Bredcom from '../../Bredcom/Main'
import Prising from '../../Menhome/Prising'

function Main() {
  return (
    <>
        <Bredcom title="Pricing" subtitle="Home" subtitledown="Pricing"/>
        <Prising/>
    </>
  )
}

export default Main